

import { useEffect, useRef } from "react";





export const useDebounce = () => {
    const timerRef = useRef(null);

    const debounce = (callback, delay = 500) => {
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(callback, delay);
    };

    useEffect(() => {
        return () => clearTimeout(timerRef.current);
    }, []);

    return debounce;
};